(function() {
 
  var style = document.createElement('style');
  style.textContent = `
    .lz-anim-fade,
    .lz-anim-up,
    .lz-anim-left,
    .lz-anim-right,
    .lz-anim-scale {
      transition-property: opacity, transform;
      transition-timing-function: ease;
      transition-duration: 0.7s;
    }
    .lz-anim-fade { opacity: 0; }
    .lz-anim-fade.lz-on { opacity: 1; }
    .lz-anim-up { opacity: 0; transform: translateY(40px); }
    .lz-anim-up.lz-on { opacity: 1; transform: translateY(0); }
    .lz-anim-left { opacity: 0; transform: translateX(-50px); }
    .lz-anim-left.lz-on { opacity: 1; transform: translateX(0); }
    .lz-anim-right { opacity: 0; transform: translateX(50px); }
    .lz-anim-right.lz-on { opacity: 1; transform: translateX(0); }
    .lz-anim-scale { opacity: 0; transform: scale(0.9); }
    .lz-anim-scale.lz-on { opacity: 1; transform: scale(1); }
    .lz-d1{transition-delay:0.1s}.lz-d2{transition-delay:0.2s}
    .lz-d3{transition-delay:0.3s}.lz-d4{transition-delay:0.4s}
    .lz-d5{transition-delay:0.5s}.lz-d6{transition-delay:0.6s}
    .lz-d7{transition-delay:0.7s}.lz-d8{transition-delay:0.8s}
  `;
  document.head.appendChild(style);
 
  function add(el, anim, delay) {
    if (!el) return;
    el.classList.add(anim);
    if (delay) el.classList.add(delay);
  }
 
  function addAll(selector, anim, startDelay) {
    document.querySelectorAll(selector).forEach(function(el, i) {
      el.classList.add(anim);
      var d = Math.min((startDelay || 0) + i + 1, 8);
      el.classList.add('lz-d' + d);
    });
  }
 
  function initAnimations() {
 
    /* ── HOMEPAGE ── */
    add(document.querySelector('.lz-hero__eye'), 'lz-anim-left', 'lz-d1');
    add(document.querySelector('.lz-hero__title'), 'lz-anim-left', 'lz-d2');
    add(document.querySelector('.lz-hero__sub'), 'lz-anim-left', 'lz-d3');
    add(document.querySelector('.lz-hero__btns'), 'lz-anim-left', 'lz-d4');
    add(document.querySelector('.lz-hero__stats'), 'lz-anim-left', 'lz-d5');
 
    addAll('.lz-cat__header', 'lz-anim-fade');
    addAll('.lz-cat__card', 'lz-anim-fade', 1);
 
    addAll('.lz-mbs__header', 'lz-anim-up');
    addAll('.lz-mbs__tabs', 'lz-anim-up');
    addAll('.lz-mbs__card', 'lz-anim-up', 1);
 
    addAll('.lz-pod__header', 'lz-anim-scale');
    addAll('.lz-pod__hero', 'lz-anim-scale');
    addAll('.lz-pod__card, .lz-pod__mini, .lz-pod__item', 'lz-anim-scale', 1);
 
    add(document.querySelector('.lz-rs__left'), 'lz-anim-left', 'lz-d1');
    addAll('.lz-rs__card', 'lz-anim-left', 1);
 
    addAll('.lz-hiw__step', 'lz-anim-up', 1);
    addAll('.lz-footer__col', 'lz-anim-fade', 1);
 
    /* ── COLLECTION PAGE ── */
    /* Try both our custom classes and Rise theme classes */
    addAll('.lz-col__title, .lz-col__label, .collection-hero__title, .page-header__title', 'lz-anim-left');
    addAll('.lz-col__filters, .lz-col__tabs, .facets__form, .collection-filters', 'lz-anim-up');
    addAll(
      '.lz-col__card, .product-card, .card-product, .grid__item, .product-item',
      'lz-anim-scale', 1
    );
 
    /* ── PRODUCT PAGE ── */
    addAll(
      '.lz-prod__gallery, .product__media-gallery, .product-gallery, .product__media',
      'lz-anim-left'
    );
    addAll(
      '.lz-prod__title, .product__title, .product-title, h1.title',
      'lz-anim-up'
    );
    addAll(
      '.lz-prod__price, .product__price, .price',
      'lz-anim-up'
    );
    addAll(
      '.lz-prod__desc, .product__description, .product-description',
      'lz-anim-up'
    );
    addAll(
      '.lz-prod__btns, .product-form__buttons, .product__add-to-cart',
      'lz-anim-up'
    );
 
    /* ── CART PAGE ── */
    addAll(
      '.lz-cart__header, .cart__title, .cart-title',
      'lz-anim-up'
    );
    addAll(
      '.lz-cart__item, .cart-item, .cart__item',
      'lz-anim-up', 1
    );
    addAll(
      '.lz-cart__summary, .cart__footer, .cart-summary',
      'lz-anim-right'
    );
 
    /* ── ABOUT PAGE ── */
    addAll(
      '.lz-about__title, .page-header, .page__title',
      'lz-anim-up'
    );
    addAll(
      '.lz-about__section, .page-content p, .page-content h2, .page-content h3, .rte p',
      'lz-anim-up', 1
    );
 
    /* ── CONTACT PAGE ── */
    addAll(
      '.lz-contact__header, .lz-contact__title',
      'lz-anim-up'
    );
    addAll(
      '.lz-contact__form, .contact-form, .contact__form',
      'lz-anim-up'
    );
    addAll(
      '.lz-contact__info, .contact-info',
      'lz-anim-right'
    );
 
    /* ── GENERIC FALLBACK for any page ── */
    /* Animate any section heading and content not already caught */
    document.querySelectorAll('section, .shopify-section').forEach(function(section) {
      var heading = section.querySelector('h1, h2, h3');
      if (heading && !heading.classList.contains('lz-anim-up') && !heading.classList.contains('lz-anim-left')) {
        heading.classList.add('lz-anim-up', 'lz-d1');
      }
    });
 
    /* ── INTERSECTION OBSERVER ── */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lz-on');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
 
    document.querySelectorAll(
      '.lz-anim-fade, .lz-anim-up, .lz-anim-left, .lz-anim-right, .lz-anim-scale'
    ).forEach(function(el) {
      observer.observe(el);
    });
 
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
 
})();
 
























